import React from "react";
import Container from "../components/Container";
import licenses from "../resources/licenses.json";

/**
 * ライセンスリストアイテムコンポーネント
 * @param {string} name ライセンス名
 * @param {object} info ライセンス情報
 * @class LicenseItem
 */
const LicenseItem = ({ name, info }) => (
  <li key={name} className="licence-item">
    <h3>{name}</h3>
    <div>License: {info.licenses}</div>
    <div>{`${info.publisher ?? ""}${info.email ? `（${info.email}）` : ""}`}</div>
    {info.url && (
      <a href={info.url} target="_blank" rel="noreferrer">
        {info.url}
      </a>
    )}
  </li>
);

/**
 * ライセンスページ
 * @class LicensePage
 */
export default function LicensePage() {
  return (
    <Container title="ライセンス" isNotLogin subtitle="ライセンス">
      <div id="license-page">
        <ul>
          {Object.entries(licenses).map(([name, info]) => (
            <LicenseItem
              name={name}
              info={info}
              key={name}
              className="licence-item"
            />
          ))}
        </ul>
      </div>
    </Container>
  );
}
